import style from './style.module.css'

export default function InputText({ label, onchange, value, type }){
    return(
        <div className="form-group">
            <label className={style.label}>{label}</label>
            <input type={type || "text"} onChange={onchange} className={style.InputText + " form-control"} value={value} />
        </div>
    )
}